// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/search/v1/facet.proto" (package "c1.api.search.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { MessageType } from "@protobuf-ts/runtime";
/**
 * A FacetValue message contains count and value of the facet entry.
 *
 * @generated from protobuf message c1.api.search.v1.FacetValue
 */
export interface FacetValue {
    /**
     * The name of this facet.
     *
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * The icon for this facet.
     *
     * @generated from protobuf field: string icon_url = 2;
     */
    iconUrl: string;
    /**
     * The value of this facet.
     *
     * @generated from protobuf field: string value = 3;
     */
    value: string;
    /**
     * The count of the values in this facet.
     *
     * @generated from protobuf field: int64 count = 4;
     */
    count: number;
}
/**
 * The FacetRange message.
 *
 * @generated from protobuf message c1.api.search.v1.FacetRange
 */
export interface FacetRange {
    /**
     * The display name of the range.
     *
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * The icon of the range.
     *
     * @generated from protobuf field: string icon_url = 2;
     */
    iconUrl: string;
    /**
     * The starting value of the range.
     *
     * @generated from protobuf field: int64 from = 3;
     */
    from: number;
    /**
     * The ending value of the range.
     *
     * @generated from protobuf field: int64 to = 4;
     */
    to: number;
    /**
     * The count of items in the range.
     *
     * @generated from protobuf field: int64 count = 5;
     */
    count: number;
}
/**
 * The FacetValueItem message.
 *
 * @generated from protobuf message c1.api.search.v1.FacetValueItem
 */
export interface FacetValueItem {
    /**
     * An array of facet values.
     *
     * @generated from protobuf field: repeated c1.api.search.v1.FacetValue values = 2;
     */
    values: FacetValue[];
}
/**
 * The FacetRangeItem message.
 *
 * @generated from protobuf message c1.api.search.v1.FacetRangeItem
 */
export interface FacetRangeItem {
    /**
     * An array of facet ranges.
     *
     * @generated from protobuf field: repeated c1.api.search.v1.FacetRange ranges = 2;
     */
    ranges: FacetRange[];
}
/**
 * The FacetCategory indicates a grouping of facets by type. For example, facets "OnePassword" and "Okta" would group under an "Apps" category.
 *
 * @generated from protobuf message c1.api.search.v1.FacetCategory
 */
export interface FacetCategory {
    /**
     * The display name of the category.
     *
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * An icon for the category.
     *
     * @generated from protobuf field: string icon_url = 2;
     */
    iconUrl: string;
    /**
     * The param that is being set when checking a facet in this category.
     *
     * @generated from protobuf field: string param = 3;
     */
    param: string;
    /**
     * @generated from protobuf oneof: item
     */
    item: {
        oneofKind: "value";
        /**
         * The value of a facet category.
         *
         * @generated from protobuf field: c1.api.search.v1.FacetValueItem value = 100;
         */
        value: FacetValueItem;
    } | {
        oneofKind: "range";
        /**
         * Ranges of values in the facet.
         *
         * @generated from protobuf field: c1.api.search.v1.FacetRangeItem range = 101;
         */
        range: FacetRangeItem;
    } | {
        oneofKind: undefined;
    };
}
/**
 * Indicates one value of a facet.
 *
 * @generated from protobuf message c1.api.search.v1.Facets
 */
export interface Facets {
    /**
     * The facet being referenced.
     *
     * @generated from protobuf field: repeated c1.api.search.v1.FacetCategory facets = 1;
     */
    facets: FacetCategory[];
    /**
     * The count of items in this facet.
     *
     * @generated from protobuf field: int64 count = 2;
     */
    count: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class FacetValue$Type extends MessageType<FacetValue> {
    constructor() {
        super("c1.api.search.v1.FacetValue", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "icon_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.search.v1.FacetValue
 */
export const FacetValue = new FacetValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FacetRange$Type extends MessageType<FacetRange> {
    constructor() {
        super("c1.api.search.v1.FacetRange", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "icon_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "from", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "to", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.search.v1.FacetRange
 */
export const FacetRange = new FacetRange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FacetValueItem$Type extends MessageType<FacetValueItem> {
    constructor() {
        super("c1.api.search.v1.FacetValueItem", [
            { no: 2, name: "values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FacetValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.search.v1.FacetValueItem
 */
export const FacetValueItem = new FacetValueItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FacetRangeItem$Type extends MessageType<FacetRangeItem> {
    constructor() {
        super("c1.api.search.v1.FacetRangeItem", [
            { no: 2, name: "ranges", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FacetRange }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.search.v1.FacetRangeItem
 */
export const FacetRangeItem = new FacetRangeItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FacetCategory$Type extends MessageType<FacetCategory> {
    constructor() {
        super("c1.api.search.v1.FacetCategory", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "icon_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "param", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "value", kind: "message", oneof: "item", T: () => FacetValueItem },
            { no: 101, name: "range", kind: "message", oneof: "item", T: () => FacetRangeItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.search.v1.FacetCategory
 */
export const FacetCategory = new FacetCategory$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Facets$Type extends MessageType<Facets> {
    constructor() {
        super("c1.api.search.v1.Facets", [
            { no: 1, name: "facets", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FacetCategory },
            { no: 2, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.search.v1.Facets
 */
export const Facets = new Facets$Type();
